<template>
  <div>
    <div class="partners">
      <!-- <div class="title">合作伙伴</div>
      <div class="partner hp_flex" style="flex-wrap: wrap;">
        <template v-for="(itme, index) in 10">
          <img
            :style="{ marginRight: (index + 1) % 5 == 0 ? '' : '52px' }"
            :key="index"
            src="@/assets/index/partner.png"
            alt
          />
        </template>
      </div>-->
    </div>
    <div class="footer hp_flex">
      <div @click="goIndex" class="hp_cz_center_s logoGroup cursor-point">
        <img src="@/assets/index/logo.png" alt />
        <div class="logo">
          <p>淮南智慧医疗</p>
          <p>HUAINANZHIHUIYILIAO</p>
        </div>
      </div>
      <div class="navs">
        <div class="num">
          <div class="click">
            <span
              v-for="(item,index) in list"
              :key="index"
              @click="toback(item.path)"
              class="cursor-point"
            >{{item.name}}</span>
            <!-- <span class="cursor-point">网站首页</span>
            <span class="cursor-point">联系我们</span>
            <span class="cursor-point">帮助中心</span>
            <span class="cursor-point">隐私政策</span>-->
          </div>

          <div class="phone hp_flex">
            <a-icon style="font-size:19px;color:#929292;" type="phone" />
            <p>24小时客服热线</p>
            <p>400-000-0000</p>
          </div>
        </div>
        <div class="bottom_nav">
          <p>Copyright&copy;All Rights Reserved.</p>
          <p>淮南市智慧医疗信息化建设与考评工作领导小组</p>
          <p>淮南市数据资源管理局</p>
          <p>淮南市卫生健康委员会</p>
        </div>
        <div class="ssl_nav">
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1587403363824152576&language=CN&certType=8&url=*.hnzhyl.net" target="_blank" style="position: relative;display: inline-block;height: 38px;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/web/1587403363824152576=*.hnzhyl.net.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      list: [
        { name: "网站首页", path: "/" },
        { name: "联系我们", path: "/user-agreement/relation" },
        { name: "帮助中心", path: "/user-agreement/help" },
        { name: "隐私政策", path: "/user-agreement/privacy" },
        { name: "皖ICP备18007404号-2", path: "https://beian.miit.gov.cn" },
      ],
    };
  },
  created() {},
  methods: {
    goIndex() {
      this.$router.push({
        path: "/",
        query: {},
      });
    },
    toback(path) {
      window.scroll(0, 0);
      if (path != "/") {
        if (path.startsWith("http")) {
          window.open(path, '_blank')
        } else {
          this.$router.push(path);
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
// .partners {
//   padding-top: 67px;
//   width: 1200px;
//   margin: 0 auto;
//   .title {
//     font-size: 22px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: #333333;
//     line-height: 1;
//     margin-bottom: 37px;
//   }
//   .partner {
//     width: 100%;
//     img {
//       width: 160px;
//       height: 81px;
//       margin-bottom: 20px;
//     }
//   }
// }
.footer {
  padding-top: 34px;
  padding-bottom: 50px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  .logoGroup {
    img {
      width: 40px;
      height: 45.5px;
    }
    .logo {
      margin-left: 7.5px;
      p {
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #000000;
        margin: 0;
      }
      p:first-child {
        font-size: 30px;
        font-weight: 800;
        line-height: 1;
        margin-bottom: 7px;
      }
      p:nth-child(2) {
        font-size: 10px;
        line-height: 1;
      }
    }
  }
  .navs {
    flex: 1;
    margin-left: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    > div {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    span:not(:last-child) {
      margin-right: 36px;
    }
    .num {
      margin-bottom: 10px;
      display: flex;
      justify-items: center;
      align-items: center;
      .click {
        flex: 1;
      }
      .phone {
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          white-space: nowrap;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin: 0;
          padding-left: 20px;
        }
      }
    }
    .bottom_nav {
      width: 100%;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      p {
        white-space: nowrap;
        margin: 0;
        font-size: 8px;
      }
    }
    .ssl_nav {
      margin-top: 10px;
      text-align: center;
      width: 100%;
      font-size: 12px;
    }
  }

  // .codes {
  //   div {
  //     width: 34px;
  //     height: 34px;
  //     margin-left: 20px;
  //     img {
  //       width: 34px;
  //       height: 34px;
  //     }
  //   }
  // }
}
</style>
